 
<div class="card card-custom" style="padding: 0px 15px; margin-bottom: 20px" >
    <div class="row">
        <div class="col-md-12">           
            <table class="table" >
                <tbody>
                    <tr *ngIf="pumpPressures?.length > 0  && isToolSelected">
                        <td style="min-width: 145px">
                            <!-- Pump Pressure ( {{pumpPressureUnit}} ) -->
                            {{ 'CALC_OUTPUT.LABEL.PUMP_OUTPUT.PUMP_PRESSURE' | transloco }} ( {{ pumpPressureUnit }} )
                        </td>
                        <td style="padding: 12px" *ngFor="let pressure of pumpPressures">{{ pressure }}</td>
                    </tr>
                    <tr *ngIf="torques?.length > 0 &&  calcOutput?.input?.others?.tighteningMethod==0">
                        <td style="min-width: 145px"> Torque ( {{ torqueUnit }} )</td>
                        <td style="padding: 12px" *ngFor="let torque of torques"> {{ torque }}</td>
                    </tr>
                    <tr *ngIf="passValues?.length > 0   && (isToolSelected || calcOutput?.input?.others?.tighteningMethod==0 ) ">
                        <td style="min-width: 145px" *ngIf="!ShowSettings"> </td>
                        <td *ngIf="ShowSettings" style="min-width: 145px">
                            <!-- <a href="javascript:void(0)" (click)="openCalculationResultSettingsModal()" class="setting_icon"
                                ><i class="fa fa-cog" aria-hidden="true"></i
                            ></a> -->
                        </td>
                        <td style="padding: 12px" *ngFor="let pass of passValues"> {{ pass }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
